import { Box, Grid, Typography } from "@mui/material";
import FormField from "components/FormField";
import SelectField from "components/SelectField";
import { memo } from "react";

/* eslint-disable react/prop-types */

const provinceOptions = [
  { value: "Cần Thơ", label: "Cần Thơ" },
  { value: "Cần Thơ 2", label: "Cần Thơ 2" },
  { value: "Cần Thơ 3", label: "Cần Thơ 3" },
  { value: "Cần Thơ 4", label: "Cần Thơ 4" },
];
const districtOptions = [
  { value: "Cần Thơ 2", label: "Cần Thơ 2" },
  { value: "Cần Thơ 3", label: "Cần Thơ 3" },
  { value: "Cần Thơ 4", label: "Cần Thơ 4" },
];

function Fields2({ formData }) {
  const { formField, values, errors, touched } = formData;
  const { address2, email2, fax2, organizationName, phone2, taxId3, province2, district2 } =
    formField;
  return (
    <Box mt={3} display="flex" flexDirection="column" gap={1}>
      <Typography variant="h5">
        III. THÔNG TIN TỔ CHỨC PHÁT HÀNH CHỨNG KHOÁN HOẶC TỔ CHỨC NƠI CÁ NHÂN CÓ VỐN GÓP
      </Typography>
      <Grid mt={1} spacing={3} container>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={organizationName.name}
            label={organizationName.label}
            value={values.organizationName}
            error={errors.organizationName && touched.organizationName}
            success={values.organizationName?.toString().length > 0 && !errors.organizationName}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={taxId3.name}
            label={taxId3.label}
            value={values.taxId3}
            error={errors.taxId3 && touched.taxId3}
            success={values.taxId3?.toString().length > 0 && !errors.taxId3}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <SelectField
            options={provinceOptions}
            type={province2.type}
            label={province2.label}
            name={province2.name}
            value={values.province2}
            placeholder={province2.placeholder}
            error={errors.province2 && touched.province2}
            success={values.province2.length > 0 && !errors.province2}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <SelectField
            options={districtOptions}
            type={district2.type}
            label={district2.label}
            name={district2.name}
            value={values.district2}
            placeholder={district2.placeholder}
            error={errors.district2 && touched.district2}
            success={values.district2.length > 0 && !errors.district2}
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <FormField
            name={address2.name}
            label={address2.label}
            value={values.address2}
            error={errors.address2 && touched.address2}
            success={values.address2?.toString().length > 0 && !errors.address2}
          />
        </Grid>
        <Grid item xs={4} style={{ paddingTop: 0 }}>
          <FormField
            name={phone2.name}
            label={phone2.label}
            value={values.phone2}
            error={errors.phone2 && touched.phone2}
            success={values.phone2?.toString().length > 0 && !errors.phone2}
          />
        </Grid>
        <Grid item xs={4} style={{ paddingTop: 0 }}>
          <FormField
            name={fax2.name}
            label={fax2.label}
            value={values.fax2}
            error={errors.fax2 && touched.fax2}
            success={values.fax2?.toString().length > 0 && !errors.fax2}
          />
        </Grid>
        <Grid item xs={4} style={{ paddingTop: 0 }}>
          <FormField
            name={email2.name}
            label={email2.label}
            value={values.email2}
            error={errors.email2 && touched.email2}
            success={values.email2?.toString().length > 0 && !errors.email2}
          />
        </Grid>
      </Grid>
    </Box>
  );
}

export default memo(Fields2);
